module.exports = __webpack_public_path__ + "static/media/warcraft.5910ae89.PNG";